import {useEffect} from 'react';
import {type RouteComponentProps} from 'react-router-dom';

import type {FilterObject} from 'nutshell-core/types';

import {analyticsClient} from '../../../analytics-client';

import {PageContainer, PageTitleBar} from '../../layout';
import type {ReportURLParams} from '../../reports/report-types';

import {EngagementBarLeadsFilterControls} from '../engagement-bar-leads-filter-controls';

import {EngagementBarLeads} from './engagement-bar-leads';

interface Props extends RouteComponentProps<{page?: string; id?: string}> {
    activeFilters: FilterObject[];
    onParamChange: (params: any, replace: boolean) => void;
    urlParams: ReportURLParams<'leads'>;
}

export function EngagementBarLeadsPage(props: Props) {
    useEffect(() => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_ENGAGEMENT_LEAD_PAGE_OPENED);
    }, []);

    return (
        <PageContainer
            title='Engagement bar leads'
            whiteBackground={true}
            noPadding={true}
            pageTitleBar={
                <PageTitleBar
                    title='Engagement bar leads'
                    subheaderPrimaryText='Leads generated after visitors complete an action through the engagement bar.'
                />
            }
            controlBar={
                <EngagementBarLeadsFilterControls
                    activeFilters={props.activeFilters}
                    onParamChange={props.onParamChange}
                    urlParams={props.urlParams}
                />
            }
        >
            <EngagementBarLeads {...props} />
        </PageContainer>
    );
}
